import {Component, Input, OnInit} from '@angular/core';
import {CandidateDetailsComponent} from "../candidate-details-dialog/candidate-details.component";
import {MatDialog} from "@angular/material/dialog";
import { MessageDialogComponent } from '../../../../shared/components/message-dialog/message-dialog.component';
import { MaterialModule } from '../../../../material/material.module';
import { Router } from '@angular/router';
import { ChatService } from '../../../../services/chat.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-agency-more-detail-action-for-candidate',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './agency-more-detail-action-for-candidate.component.html',
  styleUrl: './agency-more-detail-action-for-candidate.component.scss'
})
export class AgencyMoreDetailActionForCandidateComponent implements OnInit{
  @Input() data: any = undefined;
  @Input() column: any = undefined;
  isChatActive: boolean = true;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private chatService: ChatService
  ) {}

  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
        // Subscribe to chat active status
    this.chatService.chatActive$.subscribe((isActive: boolean) => {
      this.isChatActive = isActive;
    });
    this.isChatActive = this.chatService.isChatActive;

  }

  openDetailCandidate = () => {
    console.log("DATA => ",  this.data)
    console.log("COLUMN => ",  this.column)

    this.dialog.open(CandidateDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: {right: '0'},
      backdropClass: 'bg-transparent',
      data: {
        candidature: {candidatId: this.data.id}
      },
    });
  };

  editCandidate() {
    this.router.navigate([`/agency/candidates/edit/${this.data.id}`]);
  }

  openMessageDialog(event: MouseEvent) {    
    this.dialog.open(MessageDialogComponent, {
      width: '350px',
      position: {
        top: '32px',
        right: '32px'
      },
      panelClass: ['chat-popover-panel', 'arrow-none'],
      data: {
        candidatId: this.data?.id
      }
    });
  }
}
